/*
 * @Author: lgh
 * @Date: 2024-12-10 08:44:34
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-12-01 10:42:11
 * @Description:
 */
/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * imgBaseUrl: 图片所在域名地址
 */

let baseUrl = "";

if (process.env.NODE_ENV === "development") {
	baseUrl = "http://www.pjzyjng.com";
	// baseUrl = "http://192.168.10.159:15300";
} else if (process.env.NODE_ENV === "production") {
	baseUrl = "http://www.pjzyjng.com";
	// baseUrl = "http://192.168.10.159:15300";
}

export { baseUrl };



// WEBPACK FOOTER //
// ./src/config/url.js